<div
  class="gw-flex gw-min-h-0 gw-w-full gw-flex-1 gw-flex-col gw-gap-medium gw-text-small"
>
  <span
    class="gw-flex gw-min-w-0 gw-mb-small gw-flex-1 gw-items-center gw-gap-small gw-text-text-primary gw-text-[24px] gw-leading-snug"
  >
    {{ 'features.withdrawals.modalPix.emvTitle' | translate }}
  </span>
  <gatewee-input-v2
    [id]="'withdrawal-pix-emv'"
    [form]="form"
    controlName="emv"
    type="text"
    [submitted]="submitted"
    [placeholder]="
      'features.withdrawals.modalPix.emvInputPlaceholder' | translate
    "
    [customMessages]="emvCustomMessages"
    [hint]="{
      message: 'features.withdrawals.modalPix.emvHint',
      icon: '@phi.info'
    }"
  ></gatewee-input-v2>

  <footer
    *ngIf="pixShellKind === 'dialog'"
    class="gw-shrink-0 gw-border-t gw-border-border-normal gw-bg-background-base gw-px-medium gw-pt-medium gw-pb-medium"
  >
    <ng-container *ngTemplateOutlet="emvActionFooter"></ng-container>
  </footer>
</div>

<ng-template #emvActionFooter>
  <div
    class="gw-h-px gw-w-full gw-bg-border-abnormal gw-mb-medium"
    aria-hidden="true"
  ></div>

  <div class="gw-px-medium">
    <gatewee-button
      class="gw-w-full"
      [title]="'common.actions.proceed' | translate"
      [disabled]="!canProceedFooter"
      (clicked)="attemptContinue()"
    ></gatewee-button>
  </div>
</ng-template>
